import { CASE_TAB } from "@/features/consignment-request/constants/consignmentRegistrationCase";
import { ConsignmentRequestDetailPage } from "@/features/consignment-request/pages/ConsignmentRequestDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

// Unknown tab falls back.
const SELECTABLE_CASE_TABS: string[] = [CASE_TAB.Curation, CASE_TAB.History];

export const Route = createFileRoute("/admin/consignment-request/$id/detail")({
	validateSearch: (search: Record<string, unknown>): { tab?: string } => ({
		tab: SELECTABLE_CASE_TABS.find((caseTab) => caseTab === search.tab),
	}),
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: {
					operator: "OR",
					permissions: [
						"consignment_registration.view",
						"consignment_registration.view_all",
					],
				},
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: ConsignmentRequestDetailPage,
});
